import { FormField } from "@repo/skapa";
import { Input } from "@repo/skapa";
import { Text } from "@repo/skapa";
import { ModalPrompt } from "@repo/skapa";
import { t } from "@repo/translation";
import { useState } from "react";

interface InputModalProps {
  visible: boolean;
  onClose: () => void;
  onSave: (inputValue?: string) => void;
  onCancel: () => void;
  title: string;
  message?: string;
  initialValue?: string;
}
export const InputModal = ({
  visible,
  onClose,
  onSave,
  onCancel,
  title,
  message,
  initialValue,
}: InputModalProps) => {
  const [inputValue, setInputValue] = useState(initialValue);

  return (
    <ModalPrompt
      visible={visible}
      onClose={onClose}
      title={title}
      titleId="input-modal-title"
      primaryButtonProps={{
        text: t("action.save"),
        onClick: () => {
          onSave(inputValue);
          onClose();
        },
      }}
      secondaryButtonProps={{
        text: t("action.cancel"),
        onClick: () => {
          onCancel();
          onClose();
        },
      }}
    >
      {message && <Text>{message}</Text>}
      <FormField>
        <Input
          id="tour-calendar-task-tite"
          label={t("label.title")}
          autoFocus
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              onSave(inputValue);
              onClose();
            }
          }}
        />
      </FormField>
    </ModalPrompt>
  );
};
